/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Score
 */
export interface Score {
  /**
   *
   * @type {string}
   * @memberof Score
   */
  endedAt: string
  /**
   *
   * @type {number}
   * @memberof Score
   */
  score: number
}

export function ScoreFromJSON(json: any): Score {
  return ScoreFromJSONTyped(json, false)
}

export function ScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): Score {
  if (json === undefined || json === null) {
    return json
  }
  return {
    endedAt: json['endedAt'],
    score: json['score'],
  }
}

export function ScoreToJSON(value?: Score | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    endedAt: value.endedAt,
    score: value.score,
  }
}
